// extracted by mini-css-extract-plugin
export default {"link":"IK-z","disabled":"JK-z"};